import React from 'react';
import { itemTypeClass } from '../itemTypeClass';

export default function ItemListRow({ item }) {
  const typeClass = itemTypeClass(item.type);

  return (
    <div className={`item-list-row type-${typeClass}`}>
      <div className="item-list-row__thumb">
        {item.mainImageUrl ? (
          <img src={item.mainImageUrl} alt="" loading="lazy" draggable="false" />
        ) : (
          <span className="item-list-row__thumb-placeholder" aria-hidden="true" />
        )}
      </div>

      <div className="item-list-row__name item-name">{item.itemName}</div>

      <div className="item-list-row__quantity">
        {item.quantity ? <span className="item-quantity">×{item.quantity}</span> : null}
      </div>

      <div className="item-list-row__type">
        <span className="item-type-chip">{item.type}</span>
      </div>
    </div>
  );
}
